export const BANK_ACCOUNT_TYPE_DATA = [
  { code: "C", name: "Conta Corrente" },
  { code: "S", name: "Conta Poupança" },
];

export const BUSINESS_TYPE_DATA = [
  { code: "Ltda.", name: "Sociedade Empresária Limitada" },
  { code: "EIreli", name: "Empresa Individual de Responsabilidade Limitada" },
  { code: "Individual", name: "Empresa Individual" },
  { code: "MEI", name: "Microempreendedor Indivual" },
  { code: "SS", name: "Sociedade Simples" },
  { code: "SA", name: "Sociedade Anônima" },
];

export const COMPANY_TYPE_DATA = [
      { code: "C", name: "Cliente" },
      { code: "P", name: "Parceiro" },
      { code: "O", name: "Prospecto" },
      { code: "L", name: "Indicação" },
      { code: "B", name: "Unidade de Negócio" },
];
export const EXPENSE_STATUS_DATA = [
  { code: "VALIDATION", name: "Validação", category: "default" },
  { code: "APPROVED", name: "Aprovado", category: "success" },
  { code: "REFUSED", name: "Recusado", category: "error" },
];

export const USER_TYPE_DATA = [
  { code: "U", name: "Administrador" },
  { code: "O", name: "Operador" },
  { code: "C", name: "Operador de Empresas" },
  { code: "E", name: "Participante" },
];

export const USER_TYPE = {
  ADMIN: "U",
  OPERATOR: "O",
  COMPANY_OPERATOR: "C",
  PARTICIPANT: "E"
};

export const isOperatorType = (userType) =>
  userType === USER_TYPE.OPERATOR || userType === USER_TYPE.COMPANY_OPERATOR;

export const SEX_DATA = [
  { code: "M", name: "Masculino" },
  { code: "F", name: "Feminino" },
];

export const MARITAL_STATUS_DATA = [
  { code: null, name: "Não Definido" },
  { code: "M", name: "Casado" },
  { code: "D", name: "Divorciado" },
  { code: "S", name: "Separado" },
  { code: "I", name: "Solteiro" },
  { code: "W", name: "Viúvo" },
  { code: "O", name: "Outro" },
];

export const STATES_DATA = {
  Acre: "AC",
  Alagoas: "AL",
  Amapá: "AP",
  Amazonas: "AM",
  Bahia: "BA",
  Ceará: "CE",
  "Distrito Federal": "DF",
  "Espírito Santo": "ES",
  Goiás: "GO",
  Maranhão: "MA",
  "Mato Grosso": "MT",
  "Mato Grosso do Sul": "MS",
  "Minas Gerais": "MG",
  Pará: "PA",
  Paraíba: "PB",
  Paraná: "PR",
  Pernambuco: "PE",
  Piauí: "PI",
  "Rio de Janeiro": "RJ",
  "Rio Grande do Norte": "RN",
  "Rio Grande do Sul": "RS",
  Rondônia: "RO",
  Roraima: "RR",
  "Santa Catarina": "SC",
  "São Paulo": "SP",
  Sergipe: "SE",
  Tocantins: "TO",
};

export const TRANSFER_STATUS_DATA = [
  { code: "n", name: "Novo" },
  { code: "v", name: "Validação" },
  { code: "a", name: "Aprovado", corporate: true },
  { code: "d", name: "Recusado", corporate: true },
  { code: "c", name: "Confirmado" },
  { code: "w", name: "Aguardando Confirmação" },
  { code: "t", name: "Transferindo" },
  { code: "f", name: "Recebido" },
  { code: "p", name: "Pagando" },
  { code: "i", name: "Erro no Processo" },
  { code: "l", name: "Cancelado" },
  { code: "b", name: "Falha na Transferência" },
  { code: "y", name: "Re-Tentativa" },
];

export const SHAREHOLDER_TYPE_DATA = [
  { code: "p", name: "Sócio" },
  { code: "r", name: "Procurador" },
  { code: "l", name: "Representante Legal" },
];

export const SOLICITATION_SCHEDULE_PAYMENT_TYPE_DATA = [
  { code: "S", name: "Saldo em conta" },
  { code: "P", name: "Boleto\"Pix\"" },
];

export const SOLICITATION_TYPE = {
  WITHDRAWAL: { code: "W", name: "Saque" },
	CHARGE:     { code: "C", name: "Carga" },
	CREDIT:     { code: "T", name: "Crédito" },
	REFUND:     { code: "R", name: "Reembolso" },
	CARD:       { code: "D", name: "Cartão" },
	REDEEM:     { code: "E", name: "Resgate" },
	SCHEDULE:   { code: "S", name: "Agendamento" }
}

export const SOLICITATION_STATUS = {
  WAITING_PRE_REGISTER: { code :"W", name: "Aguardando Pré-Cadastro" },
  PENDING: { code :"D", name: "Pendente" },
	LOADING: { code :"H", name: "Carregando" },
	FINAL: { code :"I", name: "Finalizado" },
	APPROVED: { code :"A", name: "Aprovado" },
	REFUSED: { code :"R", name: "Recusado" },
	PAID: { code :"P", name: "Pago" },
	EXPIRED: { code :"E", name: "Expirado" },
	FAIL: { code :"F", name: "Falha" },
	CANCELED: { code :"C", name: "Cancelado" },
	PENDING_SCHEDULED: { code :"Q", name: "Agendamento Pendente" },
	SCHEDULED: { code :"S", name: "Agendado" },
  CANCELED_SCHEDULED: { code: "Z", name: "Agendamento Cancelado por falta de pagamento" }
}

export const ANNUAL_REVENUE_RANGE_DATA = [
  {code: "up_to_50k", name: "Até 50 Mil"},
  {code: "from_50k_to_500k", name: "De 50 Mil a 500 Mil"},
  {code: "from_500k_to_5m", name: "De 500 Mil a 5 Milhões"},
  {code: "from_5m_to_50m", name: "De 5 Milhões a 50 Milhões"},
  {code: "above_50m", name: "Acima de 50 Milhões"}
]

export const MONTHLY_REVENUE_RANGE_DATA = [
  {code: "0_to_1_sm", name: "De 0 a 1 Salário Mínimo"},
  {code: "1_to_2_sm", name: "De 1 a 2 Salários Mínimos"},
  {code: "2_to_3_sm", name: "De 2 a 3 Salários Mínimos"},
  {code: "3_to_5_sm", name: "De 3 a 5 Salários Mínimos"},
  {code: "5_to_7_sm", name: "De 5 a 7 Salários Mínimos"},
  {code: "7_to_10_sm", name: "De 7 a 10 Salários Mínimos"},
  {code: "10_to_15_sm", name: "De 10 a 15 Salários Mínimos"},
  {code: "15_to_20_sm", name: "De 15 a 20 Salários Mínimos"},
  {code: "over_20_sm", name: "Acima de 20 Salários Mínimos"}
]

export const REPRESENTATIVE_LEGAL_DATA = [
  { code : "legal_representative", name: "Representante Legal"},
  { code : "attorney_in_fact", name: "Procurador"},
  { code : "representative_foreign", name: "Representante Estrangeiro"},
  { code : "tutor", name: "Tutor"},
  { code : "emancipated_minor", name: "Menor Emancipado"}
]

export const biometricStatus = {
    "N":                  { text: "Participante ainda não realizou a validação facial",                     type: "initial" },
    "NOT_INITIATED":      { text: "Participante ainda não realizou a validação facial",                     type: "initial" },
    "C":                  { text: "Aguardando realização pelo participante",                                type: "initial" },
    "CREATED":            { text: "Aguardando realização pelo participante",                                type: "initial" },
    "P":                  { text: "Aguardando para análise",                                                type: "pending" },
    "PENDING":            { text: "Aguardando para análise",                                                type: "pending" },
    "I":                  { text: "Participante iniciou a realização da biometria, aguardando a conclusão", type: "analysis" },
    "IN_ANALYSIS":        { text: "Participante iniciou a realização da biometria, aguardando a conclusão", type: "analysis" },
    "IN_PROCESS":         { text: "Participante iniciou a realização da biometria, aguardando a conclusão", type: "analysis" },
    "F":                  { text: "Participante realizou a biometria, aguardando análise",                  type: "analysis" },
    "CAPTURE_COMPLETED":  { text: "Participante realizou a biometria, aguardando análise",                  type: "analysis" },
    "A":                  { text: "Aprovada",                                                               type: "finish" },
    "APPROVED":           { text: "Aprovada",                                                               type: "finish" },
    "R":                  { text: "Rejeitada",                                                              type: "error" },
    "REJECTED":           { text: "Rejeitada",                                                              type: "error" },
    "E":                  { text: "Usuário deve realizar a biometria",                                      type: "error" },
    "EXPIRED":            { text: "Usuário deve realizar a biometria",                                      type: "error" },
}

export const kycStatus = {
    "I": {
        text: "Em análise",
        type: "analysis"
    },
    "A": {
        text: "Aprovado",
        type: "finish"
    },
    "R": {
        text: "Rejeitado",
        type: "error"
    }
}